import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IndexdbService {
    constructor(private dbService: NgxIndexedDBService) { }

    getItem(key: string): Observable<any> {
        return this.dbService.getByKey('sophia-store', key);
    }

    setItem(key: string, value: any): Observable<any> {
        return this.dbService.add('sophia-store', { id: key, value: JSON.stringify(value) });
    }

    getDatosMedicos(): Observable<any> {
        return this.getDatosByKey('datos-medicos');
    }

    getDatosPersonales(): Observable<any> {
        return this.getDatosByKey('datos-personales');
    }

    private getDatosByKey(key: string): Observable<any> {
        return new Observable<any>(observer => {
            this.dbService.getByKey('sophia-store', key).subscribe(result => {
                if (result) {
                    const data = result as any;
                    const json = typeof data === 'object' && data.value ? JSON.parse(data.value) : null;
                    observer.next(json?.data ?? null);
                } else {
                    observer.next(null);
                }
                observer.complete();
            });
        });
    }
}